import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
const perks = ["Descarga inmediata", "Pago único", "Acceso de por vida", "Garantía de 7 días"];
export function FinalCta() {
  return <section className="relative overflow-hidden bg-navy-800 px-5 py-14 text-center text-white" data-id="element-71" data-mp="15dlxr8l6xexw">
      <div className="pointer-events-none absolute -right-24 top-0 h-72 w-72 rounded-full bg-brand/20 blur-3xl" data-id="element-72" data-mp="1jcv83rmptety" />
      <div className="relative mx-auto max-w-md" data-id="element-73" data-mp="1eettbiwbo1oa">
        <p className="text-sm leading-relaxed text-white/70" data-id="element-74" data-mp="1ebxtfp0wz2x7">
          Cada refinamiento que logras evitar representa más tiempo para nuevos pacientes, una mejor
          experiencia clínica y una consulta más rentable.
        </p>
        <h2 className="mt-5 font-display text-2xl font-extrabold leading-tight sm:text-3xl" data-id="element-75" data-mp="22339o5arnx81">
          Obtén acceso inmediato al{" "}
          <span className="text-brand-light" data-id="element-76" data-mp="1x5un7sil570z">Sistema Antirrefinamientos™</span>
        </h2>
        <p className="mt-3 text-sm text-white/70" data-id="element-77" data-mp="n6nr2ye1q4ws">Por solo</p>
        <div className="font-display text-6xl font-extrabold leading-none text-brand-light" data-id="element-78" data-mp="s4flbz25y345">USD $13</div>

        <ul className="mx-auto mt-6 grid max-w-xs grid-cols-2 gap-2 text-left" data-id="element-79" data-mp="x421ag9dlxgn">
          {perks.map(p => <li key={p} className="flex items-center gap-2 text-sm font-medium text-white/85" data-id="element-80" data-mp="12353zu1vvrlg">
              <CheckIcon className="h-4 w-4 shrink-0 text-brand-light" data-id="element-81" data-mp="16501soklvmuh" />
              {p}
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-82" data-mp="1b1ywb886lvt7">
          <CtaButton data-id="element-83" data-mp="1b172a1u8g651">👉 Quiero descargar el Sistema Antirrefinamientos™</CtaButton>
        </div>

        <div className="mt-8" data-id="element-84" data-mp="1fwmc8ip4dhw6">
          <CountdownTimer data-id="element-85" data-mp="1ktw92jeu8vu1" />
        </div>
      </div>
    </section>;
}